<template>
    <div v-if="participants" class="block-list-wrapper">
        <h2 v-if="showTitle" class="details-title"> {{ kStrings.kRECENT }} </h2>
        <Mub class="row mx-0 list-container" type="other" :name="otiBlockName">
            <div v-for="(item, index) in participants" :key="item.id" :id="`part-${item.id}`" class="col list-item" :data-id="item.id">
                <div class="w-100 h-100 position-absolute">
                    <a class="click-layer" :href="item.url" :data-clkid="item.clickId" :aria-label="item.name" @click.exact="goToPage(item.url, item.id)"> &nbsp; </a>
                    <div class="shadow-layer" />
                    <LoadImageLazy :classNames="'img-block img-fluid'" :classNamesBox="'w-100 h-100'" :loadingStyles="{height: '100%'}" :srcImg="item.image" :title="item.name + '-' + item.id" />
                    <div class="item-info">
                        <div class="description" v-html="item.name" />
                        <div class="description extra" v-html="item.subtitle" />
                    </div>
                    <div v-if="item.rankingLabel" class="w-auto stacked-label" :class="item.rankingCssClass">
                        <div class="label-rank">
                            <i class="ecom-trophy"/>
                            {{ item.rankingLabel }}
                        </div>
                        <div ref="label" class="label-likes">
                            <i class="ecom-favourite-full" />
                            {{ item.likes }}
                        </div>
                    </div>
                    <div v-else class="item-label"> <i class="ecom-favourite-full" /> {{ item.likes }} </div>
                </div>
            </div>
        </Mub>

        <div v-if="pagination" class="button-wrapper load-wrapper">
            <button v-if="isDesktop" v-show="!isLoading" class="pastime-button light" @click="loadMore"
                id="btn-load-more"> {{ kStrings.kSHOW_MORE }} </button>
            <div v-else v-show="!isLoading" class="w-100" id="btn-load-more" style="height: 20px;">&nbsp;&nbsp;</div>
            <div v-if="isLoading" class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>

const PASTIMES_ORDER_BY_DATE = 'CREATION_DATE';
const PASTIMES_ORDER_BY_VOTED = 'MOST_VOTED';
const PASTIMES_ANCHOR_REGID = 'pid';
const PASTIMES_ANCHOR_TOP   = 'ptp';
const PASTIMES_ANCHOR_PAGE  = 'ppg';

import LoadImageLazy from '@/components/LoadImageLazy';
import { store } from '@/store/pastimes';
import { isEmpty } from 'lodash-es';
import Mub from '@/components/Mub';

export default {
    store,
    name: 'ParticipantsList',
    components: {
        LoadImageLazy,
        Mub,
    },
    props: {
        showTitle: { type: Boolean, default: false, required: false },
        isRanking: { type: Boolean, default: false, required: false },
    },
    data() {
        return {
            autoLagesLeft: 12,
            observer: null,
            viewPortPosition: null
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        participants() {
            const data = this.$store.getters.participants;
            return !isEmpty(data) ? data : null;
        },
        pagination() {
            return this.$store.getters.pagination !== null;
        },
        isLoading() {
            return this.$store.getters['participantsList/isLoading'];
        },
        page() {
            return this.$store.getters['participantsList/currentPage'];
        },
        otiBlockName(){
            return this.$store.getters['participantsList/otiBlockName'];
        }
    },
    watch: {
        participants() {
            if (this.isDesktop) {
                this.autoLagesLeft--;
            }
        }
    },
    mounted() {
        let order = this.isRanking ? PASTIMES_ORDER_BY_VOTED : PASTIMES_ORDER_BY_DATE;
        this.$store.dispatch('participantsList/orderBy', order);
        this.pagePosition();
        this.observerLoad();
    },
    methods: {
        scrollTo(viewPortPosition){
            if(!viewPortPosition){
                return;
            }
            let elem   = document.querySelector(`#part-${viewPortPosition.id}`);
            if(elem){
                let s = elem.offsetTop + elem.offsetParent.offsetTop - viewPortPosition.position;
                window.scrollTo({
                    top: s, 
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },
        pagePosition(){
            let params = new URLSearchParams(window.location.search);
            let post   = params.get(PASTIMES_ANCHOR_TOP);
            let pos    = post ? parseFloat(post) : null;
            let id     = params.get(PASTIMES_ANCHOR_REGID);
            let page   = params.get(PASTIMES_ANCHOR_PAGE); 
            if(page && id && pos){
                let viewPortPosition = {
                    position: pos,
                    id: id
                };
                this.scrollTo(viewPortPosition);
                params.delete(PASTIMES_ANCHOR_TOP);
                params.delete(PASTIMES_ANCHOR_REGID);
                params.delete(PASTIMES_ANCHOR_PAGE);
                let p = params.toString();
                window.history.replaceState({}, document.title, window.location.pathname + (p != '' ? "?" + p : ''));
            }
        },
        goToPage(url, id) {
            if (!url || url == '#' || !id) {
                return;
            }
            let elem   = document.querySelector(`#part-${id}`);
            if(elem){
                let bound  = elem.getBoundingClientRect();
                let params = new URLSearchParams(window.location.search);
                params.set(PASTIMES_ANCHOR_PAGE, this.page);
                params.set(PASTIMES_ANCHOR_TOP, bound.top);
                params.set(PASTIMES_ANCHOR_REGID, id);
                window.history.replaceState({}, document.title, window.location.pathname + "?" + params.toString());
            }
            window.location.assign(url);
        },
        observerLoad() {
            let options = {
                root: null,
                rootMargin: '200px',
                threshold: 1,
                once: true
            };

            let callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.isLoading) {
                        this.autoLoad();
                    }
                });
            };

            this.observer = new IntersectionObserver(callback, options);
            let target = document.getElementById('btn-load-more');
            if (target) {
                this.observer.observe(target);
            }
        },
        loadMore() {
            this.$store.dispatch('participantsList/loadMore');
        },
        autoLoad() {
            /*if (this.autoLagesLeft <= 0) {
                return;
            }*/
            this.loadMore();
        },
    }
};
</script>
